import React from "react";
import { Box, Chip, Tab, Tabs } from "@mui/material";
import palette from "../../../theme/palette";
import { iEventDetailCMS, iEventType } from "../../../types/eventTypes";
import QuotesTabContentB2C from "./tabs/QuotesTabContentB2C";
import B2CEventTabContent from "./b2c-event-tab-content/B2CEventTabContent";
import { EventDetailTabsEnum } from "../../../constants/eventDetail";
import useTimer from "../../../hooks/useTimer";
import DeclineReasonBanner from "../b2b/event-details/decline-reason-banner/DeclineReasonBanner";
import { getB2CEventDeclineReason } from "../../../helpers/common";
import { EventSourceEnum } from "../../../constants/enums";
import "./eventDetailsSection.scss";

interface EventDetailsSectionProps {
	expireAt?: string;
	selectedTab: EventDetailTabsEnum;
	eventDetail: iEventType;
	selectedType: string;
	cms: iEventDetailCMS;
	onHold: boolean;
	isEventDeclined: boolean;
	OnClickTriggerLeftContainerScroll?: () => void;
	setSelectedTab: (tab: EventDetailTabsEnum) => void;
	onClickAddAdditionalQuote?: () => void;
}

const EventDetailsSection: React.FC<EventDetailsSectionProps> = ({
	expireAt,
	onHold = false,
	selectedTab,
	eventDetail,
	selectedType,
	cms,
	setSelectedTab,
	onClickAddAdditionalQuote,
	isEventDeclined,
	OnClickTriggerLeftContainerScroll,
}) => {
	const timeLeft = useTimer({ expireAt, eventRequestId: eventDetail?.request?.id || "" });

	const handleTabChange = (newValue: EventDetailTabsEnum) => {
		setSelectedTab(newValue);
	};

	return (
		<Box className="eventDetailsSectionB2C">
			{/* Main Tabs: Event & Quotes */}
			<Box className="mainTabsContainer">
				<Tabs
					value={selectedTab}
					onChange={(_, newValue) => {
						handleTabChange(newValue);
						OnClickTriggerLeftContainerScroll?.();
					}}
					className="mainTabs"
					classes={{
						list: "tabsFlexContainer",
					}}
					slotProps={{
						indicator: {
							style: { backgroundColor: palette.primary.main, height: "2px" },
						}
					}}
				>
					<Tab
						label="Event"
						value={EventDetailTabsEnum.Details}
						className={`mainTab ${selectedTab === EventDetailTabsEnum.Details ? "active" : ""}`}
					/>
					{eventDetail?.source !== EventSourceEnum.shopify && <Tab
						label="Quotes"
						value={EventDetailTabsEnum.MyQuote}
						className={`mainTab ${selectedTab === EventDetailTabsEnum.MyQuote ? "active" : ""}`}
					/>}
				</Tabs>

				{(onHold || timeLeft) && (
					<Box sx={{ padding: "19px 0px" }}>
						<Chip
							label={onHold ? "Hold" : timeLeft}
							sx={{
								bgColor: "rgba(180, 35, 24, 0.11)",
								color: onHold ? "#E5A545" : palette.error.main,
								fontSize: 12,
								fontWeight: 500,
								height: 28,
								px: 1,
							}}
						/>
					</Box>
				)}
			</Box>

			{isEventDeclined && (
				<DeclineReasonBanner declineReason={getB2CEventDeclineReason(eventDetail as iEventType) || ""} />
			)}

			{/* Tab Content */}
			<Box className={`tabContent`}>
				{selectedTab === EventDetailTabsEnum.Details && (
					<B2CEventTabContent
						eventDetail={eventDetail}
						selectedType={selectedType}
						cms={cms}
						request={eventDetail?.request || undefined}
					/>
				)}
				{selectedTab === EventDetailTabsEnum.MyQuote && (
					<QuotesTabContentB2C
						eventDetail={eventDetail}
						cms={cms}
						onClickAddAdditionalQuote={onClickAddAdditionalQuote}
						isEventDeclined={isEventDeclined}
					/>
				)}
			</Box>
		</Box>
	);
};

export default EventDetailsSection;
